<!--
 * @Author: sipeng
 * @LastEditTime: 2023-06-13 16:33:42
 * @Description:
-->
<template>
  <div>
    <div class="h-100 p-10 position-absolute" :style="{ height: height, top: top }" id="fence-list">
      <el-row class="table-header m-b-5 business_dialog_title">
        <el-col :span="12">
          <span class="fz-14">门禁详细列表</span>
        </el-col>
        <el-col :span="12" class="tr">
          <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
        </el-col>
      </el-row>
      <!-- 列表 -->
      <div class="fence-table">
        <el-table :data="tableData" v-loading="tableLoading" class="w-100" height="100%">
          <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
          <el-table-column align="center" prop="personName" label="人员名称"> </el-table-column>
          <el-table-column align="center" prop="jobNo" label="人员唯一编号"> </el-table-column>
          <el-table-column align="center" prop="orgName" label="组织名称"> </el-table-column>
          <el-table-column align="center" prop="doorName" label="设备名称"> </el-table-column>
          <el-table-column align="center" prop="devName" label="设备编码"> </el-table-column>
          <el-table-column align="center" prop="inAndOutTypeName" label="出入事件">
          </el-table-column>
          <el-table-column align="center" prop="eventTime" label="事件产生时间"> </el-table-column>
        </el-table>
      </div>
      <div class="m-t-5 r">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total,prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import AccessControlSecurity from '@/services/baoChang/accessControlSecurity'

export default {
  name: 'AccessControlList',
  components: {},
  props: ['documentId', 'player', 'height', 'top'],
  data() {
    return {
      tableLoading: false,
      tableData: [], // 列表
      pageSize: 15,
      pageNo: 1,
      pageTotal: null,
    }
  },
  async created() {
    await this.getAccessControlList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  watch: {},
  methods: {
    // 关闭弹窗
    closeComponent() {
      if (this.tableLoading) {
        return
      }
      this.$emit('closeComponent', 'AccessControlList')
    },
    // 获取门禁列表
    async getAccessControlList() {
      this.tableLoading = true
      const payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      const res = await AccessControlSecurity.getAccessControl(payload)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data.data.list.map((it) => {
          it.eventTime = it.eventTime
            .split('T')
            .join(' ')
            .split('+')
            .splice(0, 1)
            .join()
          return it
        })
        this.pageTotal = res.data.data.total
      }
    },
    handleSizeChange() {
      this.pageSize = 1
      this.getAccessControlList()
    },
    handleCurrentChange(page) {
      this.pageNo = page
      this.getAccessControlList()
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';
#fence-list {
  width: 750px;
  right: 35px;
  border-radius: 2px;
  z-index: 99;
  transition: left 0.3s;
  background-color: rgba(46, 107, 176, 0.5) !important;
  z-index: 99;
  .fence-table {
    height: calc(100% - 60px);
  }
}
.table-header {
  color: #ffffff;
}

</style>
